const themeColors = {
	// 서비스 자동 색. 에러 막대(--danger-background #f0531c)와 헷갈리는 빨강·주황 계열은
	// 넣지 않는다 — 정상 스팬이 에러처럼 보인다. (#FF6633 은 에러 색과 OKLab ΔE 4.8)
	traceDetailColors: {
		robin: '#3F5ECC',
		dodgerBlue: '#2F80ED',
		mediumOrchid: '#BB6BD9',
		turquoiseBlue: '#56CCF2',
		festivalOrange: '#F2C94C',
		silver: '#BDBDBD',
		canary: '#FFFF99',
		deepSkyBlue: '#00B3E6',
		goldTips: '#E6B333',
		royalBlue: '#3366E6',
		avocado: '#999966',
		mintGreen: '#99FF99',
		lima: '#80B300',
		olive: '#809900',
		danube: '#6680B3',
		oliveDrab: '#66991A',
		lavenderRose: '#FF99E6',
		electricLime: '#CCFF1A',
		turquoise: '#33FFCC',
		gladeGreen: '#66994D',
		hemlock: '#66664D',
		vidaLoca: '#4D8000',
		mediumAquamarine: '#66CDAA',
		lavender: '#E6E6FA',
		thistle: '#D8BFD8',
		yellow: '#FFFF00',
		purple: '#800080',
		cyan: '#00FFFF',
	},
	chartcolors: {
		// Blues (3)
		dodgerBlue: '#2F80ED',
		royalBlue: '#3366E6',
		steelBlue: '#4682B4',

		// Teals / Cyans (3)
		turquoise: '#00CEC9',
		lagoon: '#1ABC9C',
		cyanBright: '#22A6F2',

		// Greens (3)
		emeraldGreen: '#27AE60',
		mediumSeaGreen: '#3CB371',
		limeGreen: '#A3E635',

		// Yellows / Golds (3)
		festivalYellow: '#F2C94C',
		sunflower: '#FFD93D',
		warmAmber: '#FFCA28',

		// Oranges (3)
		festivalOrange: '#F2994A',
		coralOrange: '#E17055',
		pumpkin: '#FF7F50',

		// Reds (3)
		radicalRed: '#FF1A66',
		crimsonRed: '#EB5757',
		fireRed: '#E10600',

		// Pinks (3)
		hotPink: '#E84393',
		rosePink: '#FD79A8',
		blush: '#FF7EB6',

		// Purples / Violets (3)
		mediumPurple: '#BB6BD9',
		royalPurple: '#9B51E0',
		orchid: '#DA77F2',

		// Accent / Neon / Unique Colors (3)
		neonViolet: '#C77DFF',
		electricPurple: '#6C5CE7',
		arcticBlue: '#48DBFB',

		// Extended palette — systematic variations to reach 100 colors
		blue1: '#1F63E0',
		blue2: '#3A7AED',
		blue3: '#5A9DF5',
		cyan1: '#00B0AA',
		cyan2: '#33D6C2',
		cyan3: '#66E9DA',
		green1: '#1E8449',
		green2: '#2ECC71',
		green3: '#58D68D',
		yellow1: '#F1C40F',
		yellow2: '#F7DC6F',
		yellow3: '#F9E79F',
		orange1: '#D35400',
		orange2: '#E67E22',
		orange3: '#F5B041',
		red1: '#C0392B',
		red2: '#E74C3C',
		red3: '#EC7063',
		pink1: '#D81B60',
		pink2: '#E91E63',
		pink3: '#F06292',
		purple1: '#8E44AD',
		purple2: '#9B59B6',
		purple3: '#BB8FCE',
		teal1: '#009688',
		teal2: '#1ABC9C',
		teal3: '#48C9B0',
		lime1: '#A3E635',
		lime2: '#B9F18D',
		lime3: '#D4FFB0',
		gold1: '#F39C12',
		gold2: '#F1C40F',
		gold3: '#F7DC6F',
		coral1: '#E67E22',
		coral2: '#F39C12',
		coral3: '#F5B041',
		crimson1: '#C0392B',
		crimson2: '#E74C3C',
		crimson3: '#EC7063',
		violet1: '#8E44AD',
		violet2: '#9B59B6',
		violet3: '#BB8FCE',
		aqua1: '#00BFFF',
		aqua2: '#1E90FF',
		aqua3: '#63B8FF',
		forest1: '#27AE60',
		forest2: '#2ECC71',
		forest3: '#58D68D',
		blush1: '#FF6F91',
		blush2: '#FF85A2',
		blush3: '#FFA0B3',
		lavender1: '#9B59B6',
		lavender2: '#AF7AC5',
		lavender3: '#C39BD3',
		tomato1: '#E74C3C',
		tomato2: '#EC7063',
		tomato3: '#F1948A',
		salmon1: '#FF6B6B',
		salmon2: '#FF8787',
		salmon3: '#FFA1A1',
		mustard1: '#F1C40F',
		mustard2: '#F7DC6F',
		mustard3: '#F9E79F',
		teal4: '#1ABC9C',
		teal5: '#48C9B0',
		teal6: '#76D7C4',
		magenta1: '#D6336C',
		magenta2: '#E84393',
		magenta3: '#F06292',
		violet4: '#7D3C98',
		violet5: '#8E44AD',
		violet6: '#9B59B6',
		green4: '#229954',
		green5: '#27AE60',
		green6: '#52BE80',
		blue4: '#2874A6',
		blue5: '#2E86C1',
		blue6: '#3498DB',
		red4: '#C0392B',
		red5: '#E74C3C',
		red6: '#EC7063',
		orange4: '#D35400',
		orange5: '#E67E22',
		orange6: '#EB984E',
		pink4: '#C2185B',
		pink5: '#D81B60',
		pink6: '#E91E63',
		gold4: '#B7950B',
		gold5: '#F1C40F',
		gold6: '#F4D03F',
	},
	lightModeColor: {
		radicalRed: '#D81B60',

		dodgerBlueDark: '#1E5BD9',
		steelgrey: '#344B6B',
		steelpurple: '#5E548E',
		steelindigo: '#8E4A7C',
		steelpink: '#B63A6F',
		steelcoral: '#E14B5A',
		steelorange: '#E76F2F',
		steelgold: '#E09B00',
		steelrust: '#C93A50',
		steelgreen: '#2F7D69',

		mediumOrchidDark: '#8E24AA',
		seaBuckthornDark: '#C75A00',
		seaGreen: '#1E7F5A',
		turquoiseBlueDark: '#007EA7',
		silverDark: '#5F5F5F',
		outrageousOrangeDark: '#E64A19',
		roseBudDark: '#D84315',
		deepSkyBlueDark: '#0277BD',
		royalBlue: '#2A4FDB',

		avocadoDark: '#6B6B1E',
		mintGreenDark: '#2E9E55',
		chestnut: '#8B3A3A',
		limaDark: '#5C7F00',
		olive: '#6E7F00',
		beautyBushDark: '#C93C3C',

		danube: '#4F6FB3',
		oliveDrab: '#4F7F1A',
		lavenderRoseDark: '#B0178F',
		electricLimeDark: '#6B8F00',
		robin: '#2F4FCC',

		harleyOrange: '#CC2E12',
		gladeGreen: '#4F7F46',
		hemlock: '#5C5C45',
		vidaLoca: '#3D6B00',
		rust: '#993300',

		red: '#C62828',
		blue: '#1A237E',
		green: '#1B7F3A',
		purple: '#6A1B9A',
		magentaDark: '#B000B5',
		pinkDark: '#C2185B',

		brown: '#7A3A1E',
		teal: '#006D6F',
		limeDark: '#4C8C2B',
		maroon: '#6D1B1B',
		navy: '#0D1B5E',
		gray: '#616161',

		skyBlueDark: '#0288D1',
		indigo: '#303F9F',
		slateGray: '#556B7C',
		chocolate: '#9C4A1A',
		tomato: '#E53935',
		steelBlue: '#3A6EA5',

		peruDark: '#B35E00',
		darkOliveGreen: '#445B1F',
		indianRed: '#B04040',
		mediumSlateBlue: '#5C6BC0',
		rosyBrownDark: '#A94444',
		darkSlateGray: '#2E4A4A',

		fuchsia: '#C511C5',
		salmonDark: '#E64A3C',
		darkSalmonDark: '#C85A3A',
		paleVioletRedDark: '#C2186A',

		mediumPurple: '#7E57C2',
		darkOrchid: '#7B1FA2',
		mediumSeaGreenDark: '#2E8B57',
		lightCoralDark: '#E57373',

		gold: '#D4AF37',
		sandyBrownDark: '#C76A15',
		darkKhakiDark: '#8A7F00',
		cornflowerBlueDark: '#355FCC',
		mediumVioletRed: '#AD1457',
		paleGreenDark: '#2E7D32',
	},
	errorColor: '#d32f2f',
	royalGrey: '#888888',
	matterhornGrey: '#555555',
	whiteCream: '#ffffffd5',
	white: '#ffffff',
	black: '#000000',
	darkGrey: '#262626',
	lightBlack: '#141414',
	lightgrey: '#ddd',
	lightWhite: '#ffffffd9',
	borderLightGrey: '#d9d9d9',
	borderDarkGrey: '#424242',
	gainsboro: '#DBDBDB',
	navyBlue: '#1668DC',
	lightSkyBlue: '#8DCFF8',
	neroBlack: '#1d1d1d',
	snowWhite: '#fafafa',
	gamboge: '#D89614',
	bckgGrey: '#1d1d1d',
	lightBlue: '#177ddc',
	buttonSuccessRgb: '73, 170, 25',
	red: '#E84749',
};

export { themeColors };
